import React from 'react';

export function renderChildren(children, props) {
    if (!children) return null;
    if (Array.isArray(children)) {
        return (
            children.map((child, index) => React.cloneElement(child, { key: index, ...props }))
        )
    } else if (!Array.isArray(children) && props !== undefined) {
        return (
            <>{React.cloneElement(children, props)}</>
        )
    } else if (!Array.isArray(children)) {
        return (
            <>{children}</>
        )
    }
    return null;
}

//test if message contain html tags
export function isMessageHtml(message) {
    return (/<\/?[a-z][\s\S]*>/i.test(message));
}